import {
  BsBellFill,
  BsCurrencyBitcoin,
  BsFileBarGraphFill,
  BsTrophyFill,
} from "react-icons/bs";
import {
  FaAnchor,
  FaBullseye,
  FaGlobeAmericas,
  FaMoneyBillWave,
  FaTractor,
  FaBaseballBall,
} from "react-icons/fa";

const addons = [
  {
    key: "bullseye_ai_trade_ideas",
    description:
      "AI algorithms identify opportunities to monetize within 1-5 trading days.",
    price: 99,
    name: "Bullseye AI Trade Ideas",
    icon: FaBullseye,
  },
  {
    key: "income_dashboard",
    description:
      "A dashboard of market prices and signals for key fixed income ETFs.",
    price: 10,
    name: "Global Fixed Income ETFs",
    icon: FaAnchor,
  },
  {
    key: "crypto_dashboard",
    description:
      "A dashboard of market prices and signals for key crypto exposures.",
    price: 10,
    name: "Cryptocurrencies",
    icon: BsCurrencyBitcoin,
  },
  {
    key: "currency_dashboard",
    description:
      "A dashboard of market prices and signals for key currency ETFs.",
    price: 10,
    name: "Global Currency ETFs",
    icon: FaMoneyBillWave,
  },
  {
    key: "sector_dashboard",
    description:
      "A dashboard of market prices and signals for key US sector ETFs.",
    price: 20,
    name: "US Sector ETFs",
    icon: BsFileBarGraphFill,
  },
  {
    key: "commodity_dashboard",
    description:
      "A dashboard of market prices and signals for key commodity ETFs.",
    price: 20,
    name: "Global Commodity ETFs",
    icon: FaTractor,
  },
  {
    key: "signal_alerts",
    description:
      "Get alerts sent to your cell phone and/or email when there is a change.",
    price: 20,
    name: "Signal Alerts",
    icon: BsBellFill,
  },
  {
    key: "equity_dashboard",
    description:
      "A dashboard of market prices and signals for key ETFs with international exposure.",
    price: 25,
    name: "Global Equity ETFs",
    icon: FaGlobeAmericas,
  },
  {
    key: "top25_dashboard",
    description:
      "Top 25 Buy and Sell tickers and their respective Longbow Trading Ranges.",
    price: 25,
    name: "Top 25",
    icon: BsTrophyFill,
  },
  {
    key: "macro_dashboard",
    description:
      "A dashboard of potential portfolio positions as selected by external, independent research provider 42 Macro.",
    price: 20,
    name: "Macro Dashboard",
    icon: FaBaseballBall,
  },
];

export default addons;
